const DEFAULT_DESCRIPTION =
  "Access your child's progress, upcoming sessions, reports, and billing information in one secure place. myMathnasium is a fast, mobile-friendly app designed for Mathnasium parents to stay connected and informed.";
interface HeadProps {
  title?: string;
  description?: string;
}

export const Head = ({ title = '', description = DEFAULT_DESCRIPTION }: HeadProps) => {
  return (
    <>
      <title>{title ? `${title} | myMathnasium` : 'myMathnasium'}</title>
      <meta name='description' content={description} />
    </>
  );
};
